<template>
    <div>
        <!-- 大播放 --->
        <div class="w-full" v-if="track && isOpen">
            <ProgressBar style="margin-bottom: -5px; margin-top: -6px;" />
            <div class="flex">
                <!-- Track info --->
                <div class="w-4/12">
                    <div class="flex items-center">
                        <div @click="handlePlayingDetails" class="mx-2 h-16 w-16 my-1 hover:brightness-50 cursor-pointer">
                            <img v-if="track.image" :src="track.image"
                                 class="rounded-md"
                                style="width: 56px; height: 56px; object-fit: cover;">
                            <img v-else src="/static/dist/img/album_null.jpg" style="width: 56px; height: 56px; object-fit: cover;">
                        </div>
                        <div class="min-w-0 flex-1">
                            <router-link :to="{ name: 'album', params: { id: track.albumId } }" class="hover:underline">
                                <div class="truncate">
                                    {{ streamTitle || track.title }}
                                </div>
                            </router-link>
                            <router-link :to="{ name: 'artist', params: { id: track.artistId } }" class="hover:underline">
                                <div class="truncate text-gray-400 text-xs">
                                    {{ track.artist || track.album }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>

                <!-- Controls--->
                <div class="flex flex-1 items-center justify-center">
                    <button variant="link" class="m-2 d-none d-sm-inline-block" @click="previous">
                        <svg-icon name="player-previous" class="fill-current hover:fill-gray-600"></svg-icon>
                    </button>
                    <label class="swap swap-flip">
                        <input type="checkbox" v-model="isPlaying" />
                        <svg-icon name="player-play" class="swap-off fill-current w-8 h-8 hover:fill-gray-600"></svg-icon>
                        <svg-icon name="player-pause" class="swap-on fill-current w-8 h-8 hover:fill-gray-600"></svg-icon>
                    </label>
                    <button variant="link" class="m-2" @click="next">
                        <svg-icon name="player-next" class="fill-current hover:fill-gray-600"></svg-icon>
                    </button>
                </div>
                <!-- Controls right --->
                <!-- 音量 --->
                <div class="w-4/12 flex items-center justify-end pr-3">
                    <!-- 播放队列 --->
                    <button variant="link" class="m-2 d-none d-sm-inline-block md:!hidden" @click="openModal">
                        <svg-icon name="playlist" class="icon fill-current w-5 h-5"></svg-icon>
                    </button>
                    <div class="dropdown dropdown-top m-2 !hidden md:!flex">
                        <label tabindex="0">
                            <svg-icon name="player-volume" class="icon fill-current w-5 h-5" :viewBox="'0 0 24 24'"></svg-icon>
                        </label>
                        <ul tabindex="0" class="dropdown-content z-[1] menu p-2 shadow bg-base-100 rounded-box">
                            <vue-slider class="pt-2" style="height: 120px;" direction="btt"
                                :min="0" :max="100" :step="1"
                                :value="volume" @change="setVolume"
                            ></vue-slider>
                        </ul>
                    </div>
                    <!-- 收藏 --->
                    <button variant="link" class="m-2 d-none d-sm-inline-block !hidden md:!flex" @click="addFavouriteTrack(track)">
                        <svg-icon name="player-favourite" :class="['h-5', 'w-5', track.favourite ? 'fill-current' : '']" :viewBox="'0 0 24 24'" fill="none" stroke="currentColor"></svg-icon>

                    </button>
                    <!-- 循环播放 --->
                    <button variant="link" size="lg" class="m-2 !hidden md:!flex" @click="toggleRepeat">
                        <svg-icon name="player-repeat" :class="['h-5', 'w-5', repeat ? 'fill-primary' : 'fill-current']"></svg-icon>

                    </button>
                    <!-- 随机播放 --->
                    <button variant="link" class="m-2 !hidden md:!flex" @click="toggleShuffle">
                        <svg-icon name="player-shuffle" :class="['h-5', 'w-5', shuffle ? 'fill-primary' : 'fill-current']"></svg-icon>
                    </button>
                    <button variant="link" class="m-2 !hidden md:!flex" @click="close">
                        <svg-icon name="player-close" class="icon fill-current w-5 h-5"></svg-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- 小播放 --->
        <div class="w-full relative" v-if="track && !isOpen">
            <div class="absolute -left-2/4 -bottom-4 bg-base-200 rounded-xl shadow-xl md:w-56">
                <ProgressBar style="margin-bottom: -5px; margin-top: -6px;" />
                <div class="flex flex-col">
                    <!-- Track info --->
                    <div>
                        <div class="flex items-center justify-center">
                            <div @click="handlePlayingDetails" class="mx-2 h-16 w-16 mt-2 hover:brightness-50 cursor-pointer">
                                <img v-if="track.image" :src="track.image" style="width: 56px; height: 56px; object-fit: cover;">
                                <img v-else src="/static/dist/img/album_null.jpg" style="width: 56px; height: 56px; object-fit: cover;">
                            </div>
                            <div class="min-w-0 flex-1">
                                <router-link :to="{ name: 'album', params: { id: track.albumId } }" class="hover:underline">
                                    <div class="truncate">
                                        {{ streamTitle || track.title }}
                                    </div>
                                </router-link>
                                <router-link :to="{ name: 'artist', params: { id: track.artistId } }" class="hover:underline">
                                    <div class="truncate text-gray-400 text-xs">
                                        {{ track.artist || track.album }}
                                    </div>
                                </router-link>
                            </div>
                            <button variant="link" class="m-2" @click="open">
                                <svg t="1700213453662" class="icon fill-current w-5 h-5" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2411" width="64" height="64"><path d="M448 672c-6.4 0-19.2 0-25.6-6.4-12.8-12.8-12.8-32 0-44.8L531.2 512 422.4 409.6c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0l128 128c12.8 12.8 12.8 32 0 44.8l-128 128C467.2 672 454.4 672 448 672z"></path></svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 播放队列diolog --->
        <dialog id="play_queue" ref="play_queue" class="modal modal-bottom sm:modal-middle" @close="handleModalClose">
            <div class="modal-box h-5/6 !p-0">
                <h3 class="text-lg font-bold"></h3>
                <p class="">
                    <!-- 只在 modal 打开时才创建 DlnaQueue 组件，避免与路由页面的实例冲突 -->
                    <DlnaQueue v-if="isModalOpen"></DlnaQueue>
                </p>
            </div>
            <form method="dialog" class="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    </div>
</template>
<script>
    import ProgressBar from '@/views/library/player/ProgressBar'
    import DlnaQueue from '@/views/library/playing/dlnaQueue'
    import VueSlider from 'vue-slider-component'
    import {mapGetters} from 'vuex'
    import SvgIcon from '@/components/SvgIcon.vue';

    export default {
        components: {
            ProgressBar, VueSlider, SvgIcon, DlnaQueue
        },
        data() {
            return {
                isOpen: localStorage.getItem('isOpenBar') !== 'false',
                volumeDebounceTimer: null,
                isModalOpen: false  // 控制 modal 中的 DlnaQueue 组件是否创建
            }
        },
        computed: {
            ...mapGetters(['track', 'trackId', 'shuffle', 'repeat']),
            visible() {
                // return this.$store.state.player.queue.length > 0
                return true
            },
            isPlaying: {
                get() {
                    return this.$store.state.common.isPlaying
                },
                set() {
                    this.$store.dispatch('playPause')
                }
            },
            volume() {
                return Math.round(this.$store.state.common.volume * 100)
            },
            isMuted() {
                return this.$store.state.common.volume <= 0.0
            },
            repeatActive() {
                return this.$store.state.common.repeat
            },
            shuffleActive() {
                return this.$store.state.common.shuffle
            },
            isFavourite() {
                return ''
            },
            streamTitle() {
                return this.$store.state.streamTitle
            },
            documentTitle() {
                const trackTitle = this.track && this.track.title ? this.track.title : ''
                const trackArtist = this.track && this.track.artist ? this.track.artist : ''
                const trackAlbum = this.track && this.track.album ? this.track.album : ''
                return [
                    this.streamTitle || trackTitle,
                    trackArtist || trackAlbum,
                    'Music Tag Web'
                ].filter(x => !!x).join(' • ')
            }
        },
        watch: {
            documentTitle: {
                immediate: true,
                handler(value) {
                    document.title = value
                }
            },
        },
        destroyed() {
            document.title = 'Music Tag Web'
        },
        beforeDestroy() {
            // 清理音量防抖定时器
            if (this.volumeDebounceTimer) {
                clearTimeout(this.volumeDebounceTimer)
                this.volumeDebounceTimer = null
            }
        },
        methods: {
            playPause() {
                return this.$store.dispatch('playPause')
            },
            next() {
                return this.$store.dispatch('next')
            },
            previous() {
                return this.$store.dispatch('previous')
            },
            setVolume(volume) {
                // 清除之前的定时器
                if (this.volumeDebounceTimer) {
                    clearTimeout(this.volumeDebounceTimer)
                }
                
                // 设置新的定时器，300ms 后执行
                this.volumeDebounceTimer = setTimeout(() => {
                    this.$store.dispatch('setVolume', parseFloat(volume / 100))
                }, 300)
            },
            toggleRepeat() {
                return this.$store.dispatch('toggleRepeat')
            },
            toggleShuffle() {
                return this.$store.dispatch('toggleShuffle')
            },
            close() {
                localStorage.setItem('isOpenBar', 'false')
                this.isOpen = false
            },
            open() {
                localStorage.setItem('isOpenBar', 'true')
                this.isOpen = true
            },
            handlePlayingDetails() {
                console.log('handlePlayingDetails', this.$route.name)
                if (this.$route.name === 'playingList') {
                    this.$router.go(-1)
                } else {
                    this.$router.push({name: 'playingList', params: {id: this.track.id}})
                }
            },
            addFavouriteTrack(item) {
                if (item.favourite) {
                    this.$api.subsonic.removeFavourite(item.id, 'track').then((res) => {
                        item.favourite = false
                    })
                } else {
                    this.$api.subsonic.addFavourite(item.id, 'track').then((res) => {
                        item.favourite = true
                    })
                }
            },
            openModal() {
                this.isModalOpen = true
                this.$nextTick(() => {
                    this.$refs.play_queue.showModal()
                })
            },
            handleModalClose() {
                // modal 关闭时，销毁 DlnaQueue 组件以释放资源
                this.isModalOpen = false
            }
        }
    }
</script>
<style scoped>
.player {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0;
    max-height: 0;
    transition: max-height 0.5s;
}

.visible {
    height: auto;
    max-height: 100px;
}

.icon {
    display: flex;
    align-items: center;
}
/deep/ .vue-slider-process {
    background-color: oklch(var(--p)/1) !important;
}
:deep(.vue-slider-dot-tooltip-inner) {
    background-color: oklch(var(--p)/1);
    border-color: oklch(var(--p)/1);
}
</style>
